import { ModuleStructure } from './../../../../models/module-structure';
import { RecordProperties } from './../../../record-model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from 'src/app/layout/layout.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-outbound-serial',
  templateUrl: './outbound-serial.component.html',
  styleUrls: ['./outbound-serial.component.less'],
})
export class OutboundSerialComponent implements OnInit {
  serialNumbersVal = [];
  @Input() set serialNumbers(value: any[]) {
    this.serialNumbersVal = value;

    this.visibleSerialNumbers = this.serialNumbers.filter((f) => f.Selected);
    this.autoCompleteSerialNumbers = this.serialNumbers.filter(
      (f) => !f.Selected
    );
  }

  get serialNumbers() {
    return this.serialNumbersVal;
  }

  @Output() serialNumbersChange = new EventEmitter();

  @Input() selectedQty = 0;
  @Output() selectedQtyChange = new EventEmitter();

  @Input() requiredQty = 0;
  @Input() toBinActivated = false;
  @Input() toBinLocations = [];

  @Input() requiredSerialQty = 0;
  @Input() unitsOfMeasurmentProperty: RecordProperties;
  @Input() qtyProperty: RecordProperties;
  @Input() moduleStructure: ModuleStructure;

  visibleSerialNumbers = [];
  autoCompleteSerialNumbers = [];

  toBinLocationValue: number;
  serialSearchValue = '';
  screenSize = '';
  oldSerialScanned = '';

  constructor(
    private layoutService: LayoutService,
    private messageService: NzMessageService
  ) {}

  ngOnInit(): void {
    this.screenSize = this.layoutService.screenSize;
    this.layoutService.screenSizeEmitter.subscribe((d) => {
      this.screenSize = d;
    });
  }

  searchForSerial(key?) {
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    if (this.serialSearchValue == this.oldSerialScanned) {
      return;
    }

    this.oldSerialScanned = this.serialSearchValue;

    console.log(this.screenSize);

    if (
      this.toBinActivated &&
      (this.toBinLocationValue == null ||
        this.toBinLocationValue === undefined ||
        this.toBinLocationValue === 0)
    ) {
      this.messageService.error(
        this.layoutService.translate('You should choose the Receiving bin')
      );
      this.serialSearchValue = '';
      return;
    }
    const index = this.serialNumbers.findIndex(
      (i) =>
        i.DistNumber.toLowerCase() === this.serialSearchValue.toLowerCase() &&
        (i.BinAbs != this.toBinLocationValue || i.BinAbs == 0)
    );

    console.log('out bound serial');
    if (index === -1) {
      this.serialSearchValue = '';
      return;
    } else {
      //if (this.visibleSerialNumbers.length >= this.requiredQty) {
      if (this.visibleSerialNumbers.length >= this.requiredSerialQty) {
        this.messageService.error(
          this.layoutService.translate(
            'You cannot add serial numbers, selected quantity already is equal or greater than the required quantity.'
          )
        );
        return;
      }

      this.serialNumbers[index].Selected = true;
      this.serialNumbers[index].ToBinLocation = this.toBinLocationValue;
    }

    this.visibleSerialNumbers = this.serialNumbers.filter((f) => f.Selected);
    this.autoCompleteSerialNumbers = this.serialNumbers.filter(
      (f) => !f.Selected
    );

    //this.selectedQty = this.visibleSerialNumbers.length;
    this.selectedQty =
      (this.visibleSerialNumbers.length / this.requiredSerialQty) *
      this.requiredQty;
    this.selectedQtyChange.emit(this.selectedQty);
    this.serialNumbersChange.emit(this.serialNumbers);

    setTimeout(() => {
      this.serialSearchValue = '';
    }, 1);

    if (this.selectedQty === this.requiredQty && !this.qtyProperty.IsNew) {
      // this.qtyProperty.ValueAsObject = this.selectedQty;
      const scope = this;
      this.qtyProperty.DialogVisible = false;
      setTimeout(() => {
        scope.qtyProperty.DialogVisibleDrawerInitialized = false;
      }, 50);
    }
  }

  deleteSerial(serialNumber) {
    serialNumber.Selected = false;

    this.visibleSerialNumbers = this.serialNumbers.filter((f) => f.Selected);
    this.autoCompleteSerialNumbers = this.serialNumbers.filter(
      (f) => !f.Selected
    );

    //this.selectedQty = this.visibleSerialNumbers.length;
    this.selectedQty =
      (this.visibleSerialNumbers.length / this.requiredSerialQty) *
      this.requiredQty;
    this.selectedQtyChange.emit(this.selectedQty);
    this.serialNumbersChange.emit(this.serialNumbers);
  }
}
